import axios from 'axios';
import { getEnvValue } from '@tymely/config';

export const fetchOpenApiRoutes = () =>
    axios.get(getEnvValue('NX_OPENAPI_URL')).then(res => res.data);
